
const pathnames = {
  home: "/",
  signIn: "/authorize",
  CreatePasssword: "/create-password",
  enterPasssword: "/enter-password",
  initialInfo: "/initial-info",
  allSet: "/all-set",
  accounts: "/sma-groups",
  specificGroup: "/specific-group",
  specificAccount: "/specific-account",
  content: "/contents",
  specificFileGroup: "/file-group",
  settings: "/settings",
  schedulePublish: "/schedule-publish",
  scheduledPost: "/scheduled-post",
  UpgradePlan: "/upgrade-plan",
  callback: "/auth0/callback",
  notFound: "*",
};

export default pathnames;